import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { processSessionId } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    
    if (match) {
      const sessionId = match[1];
      processSessionId(sessionId).then((user) => {
        if (user) {
          // Clear hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/admin', { state: { user }, replace: true });
        } else {
          navigate('/', { replace: true });
        }
      });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, processSessionId]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#FAFAFA',
      fontFamily: 'Italiana, serif',
      fontSize: '1.5rem',
      color: '#000'
    }}>
      Authenticating...
    </div>
  );
};

export default AuthCallback;
